import {
    Component, Mixins, Emit,
} from 'vue-property-decorator';
import Classes from '@components/shared/mixins/classes';
import { YBadge, YIcon } from '@components/index';
import config from '@components/shared/config';
import Props from './props';

/**
 * @name Chips
 */
@Component({
    components: {
        YBadge,
        YIcon,
    },
})
class YChips extends Mixins(Props, Classes) {
    /**
     * Show or hidden chips
     */
    display = true;
    
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['color', 'size', 'icon', 'sharp', 'raised', 'pill', 'outline'];

    /**
     * Create Common Props for the chips.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> { // eslint-disable-line @typescript-eslint/no-explicit-any
        const commonProps: Record<string, any> = { // eslint-disable-line @typescript-eslint/no-explicit-any
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            commonProps[item] = this[item];
        });
        return commonProps;
    }

    /**
     * Create classes array for the chips.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Chips', this.commonProps, this.baseClass || config.prefix.chips));
        if (this.monochrome) {
            cls.push('is-monochrome');
        }
        if (this.text) {
            cls.push('is-text');
        }
        if (this.closeable) {
            cls.push('is-close');
        }
        if (this.bgClose) {
            cls.push('is-bg-close');
        }
        if (this.disabled) {
            cls.push('is-disabled');
        }

        if (this.closeable && this.iconAppend) {
            // eslint-disable-next-line no-useless-concat
            console.error(
                'For using'
                + '%c "closeable"'
                + '%c prop, you must remove'
                + '%c "icon-append"'
                + '%c prop in'
                + '%c "YChips".',
                'font-weight: bold',
                'font-weight: normal',
                'font-weight: bold',
                'font-weight: normal',
                'font-weight: bold',
            );
        }
        return cls;
    }

    /**
     * Return the class of the chips from config.
     * 
     * @returns {string}
     */
    get chipsClass(): string {
        return config.prefix.chips;
    }
    
    /**
     * Return inner state on icon component.
     * 
     * @returns {boolean}
     */
    get getInner(): boolean {
        return !this.outline && !this.text;
    }

    /**
     * Emit close event on callback.
     *
     * @returns {boolean}
     */
    @Emit('close')
    close(): boolean {
        this.display = false;
        return this.display;
    }
}

export default YChips;
